// src/api/index.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://dgps.co.in/api",
  // timeout: 15000,
});

// Request interceptor: token + school id set করবে
api.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem("token");
      const sid = localStorage.getItem("school_id");

      // debug log (DevTools Console এ দেখা যাবে)
      console.log("[API Interceptor] url:", config.url, "method:", config.method, "token:", Boolean(token), "sid:", sid);

      // token valid string হলে যোগ করো
      if (token && token !== "null" && token !== "undefined") {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }

      if (sid) {
        config.headers = config.headers || {};
        config.headers["X-School-Id"] = sid;
      }
    } catch (e) {
      // silent fail
      console.warn("[API Interceptor] error reading localStorage", e);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
